<div
  class="ws-switcher"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'shell.profile_panel.switch_workspace' | transloco"
  [imFocusTrap]="true"
  [imFocusTrapInitial]="searchInput()"
>
  <div class="ws-switcher__head">
    <h2 class="ws-switcher__title">{{ 'shell.profile_panel.switch_workspace' | transloco }}</h2>
    <paper-button
      intent="ghost"
      size="sm"
      shape="icon"
      icon="x"
      [ariaLabel]="'shell.profile_panel.close' | transloco"
      (click)="close()"
    />
  </div>

  <!-- A combobox over a listbox: focus stays in the field, ↑/↓ move the
       active option, Enter switches. -->
  <div class="ws-switcher__search">
    <paper-icon name="search" [size]="14" aria-hidden="true" />
    <input
      #search
      type="text"
      class="ph-mask"
      role="combobox"
      aria-autocomplete="list"
      [attr.aria-expanded]="true"
      [attr.aria-controls]="listboxId"
      [attr.aria-activedescendant]="activeId()"
      [attr.aria-label]="'shell.app_shell.search_organisations' | transloco"
      [placeholder]="'shell.app_shell.search_organisations' | transloco"
      [value]="query()"
      (input)="onQuery($any($event.target).value)"
      (keydown)="onKeydown($event)"
      autocomplete="off"
      data-testid="ws-switcher-search"
    />
  </div>

  <div
    class="ws-switcher__list"
    role="listbox"
    [id]="listboxId"
    [attr.aria-label]="'shell.app_shell.organisations' | transloco"
  >
    @for (c of ranked().items; track c.id; let i = $index) {
      <!-- Options are not focusable: focus stays in the search field and
           aria-activedescendant names the active one (the combobox pattern).
           Keyboard selection is the field's Enter handler. -->
      <div
        class="ws-switcher__option"
        role="option"
        [id]="'ws-switcher-option-' + c.id"
        [class.is-active]="i === activeIndex()"
        [class.is-current]="c.id === currentCustomerId"
        [attr.aria-selected]="c.id === currentCustomerId"
        [attr.aria-disabled]="c.id === currentCustomerId || switchingId() !== null"
        (click)="choose(c.id)"
        (mouseenter)="activeIndex.set(i)"
        [attr.data-testid]="'ws-switcher-option-' + c.id"
      >
        @if (c.logo && !logoErrors()[c.id]) {
          <span class="ws-switcher__logo" aria-hidden="true">
            <img [src]="c.logo" alt="" loading="lazy" (error)="onLogoError(c.id)" />
          </span>
        } @else {
          <paper-icon name="building" [size]="14" aria-hidden="true" />
        }
        <span class="ws-switcher__name">{{ c.name }}</span>
        @if (c.isTest) {
          <span class="ws-switcher__tag">{{ 'shell.app_shell.demo' | transloco }}</span>
        }
        @if (c.id === currentCustomerId) {
          <span class="ws-switcher__current">{{ 'shell.workspace_switcher.current' | transloco }}</span>
        } @else if (switchingId() === c.id) {
          <span class="ws-switcher__spinner" aria-hidden="true"></span>
        }
      </div>
    } @empty {
      <p class="ws-switcher__empty">{{ 'shell.app_shell.no_organisations_match' | transloco }}</p>
    }
  </div>

  @if (platformCustomers.switchError(); as switchError) {
    <p class="ws-switcher__error" role="alert" data-testid="ws-switcher-error">
      {{ 'shell.app_shell.switch_failed' | transloco: { reason: switchError.message } }}
    </p>
  }

  @if (truncated()) {
    <p class="ws-switcher__foot" data-testid="ws-switcher-truncated">
      {{
        'shell.workspace_switcher.showing_first'
          | transloco: { shown: ranked().items.length, total: ranked().total }
      }}
    </p>
  }
</div>
